(function () {
    angular.module('app')
        .controller('DateFilterController', DateFilterController);

    DateFilterController.$inject = ['$scope', '$attrs', '$location'];
    function DateFilterController($scope, $attrs, $location) {
        var ctrl = this;      
        var query = $location.search();
        var queryFound = false;
        if (query.y && query.m) {
            queryFound = true;
            $scope.params.month = parseInt(query.m);
            $scope.params.year = parseInt(query.y);
        }
        else if ($attrs.filterByDefault === 'true') {
            var now = new Date();
            $scope.params.month = now.getMonth() + 1;
            $scope.params.year = now.getFullYear();
        }

        if ($attrs.onlyPassedDates === 'true') {
            $scope.params.onlyPassedDates = queryFound;
        }

        ctrl.setDate = function (value) {
            var dateVal = new Date(value);
            var m = dateVal.getMonth()+1;
            var y = dateVal.getFullYear();
            if ($scope.params.month === m && $scope.params.year === y) {
                $scope.params.month = undefined;
                $scope.params.year = undefined;
                if ($attrs.onlyPassedDates === 'true') {
                    $scope.params.onlyPassedDates = false;
                }
            }
            else {
                $scope.params.month = m;
                $scope.params.year = y;
                if ($attrs.onlyPassedDates === 'true') {
                    $scope.params.onlyPassedDates = true;
                }
            }
        }
    }
})();